module.exports = "<div class=row> <div class=\"col s12\"> <component :is=demoName></component> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/components/real-demo.vue
 ** module id = 368
 ** module chunks = 0
 **/